import { css } from '@emotion/react';
import { theme } from '@ublend-npm/aulaui-next';

export const GlobalStyling = css`
  html,
  body {
    margin: 0;
    height: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Work Sans', sans-serif;
  }

  #root {
    margin: 0;
    height: 100%;
  }

  :root {
    --blue: ${theme.color.blue};
    --grey: ${theme.color.designSystem.grey90};
    --purple: ${theme.color.designSystem.purple70};
    --purple-light: ${theme.color.purple4};
    --purple-gradient: ${theme.color.designSystem.background.purpleGradient};
    --success: ${theme.color.designSystem.success};
    --black: ${theme.color.blackAlpha(100)};
    --black-opacity90: ${theme.color.blackAlpha(0.9)};
    --black-opacity87: ${theme.color.designSystem.blackOpacity87};
    --black-opacity60: ${theme.color.designSystem.blackOpacity60};
    --black-opacity50: ${theme.color.blackAlpha(0.5)};

    --font: ${theme.font.family.workSans};
    --font-size-small: ${theme.font.size.small};
    --font-size-copy: ${theme.font.size.copy};
    --font-size-large: ${theme.font.size.large};
    --font-size-headline: ${theme.font.size.headline};
    --font-line-height-copy: ${theme.font.lineHeight.copy};
    --font-line-height-large: ${theme.font.lineHeight.large};
    --font-weight-regular: ${theme.font.weight.regular};
    --font-weight-medium: ${theme.font.weight.medium};
    --font-weight-semi-bold: ${theme.font.weight.semiBold};
    --font-weight-bold: ${theme.font.weight.bold};

    --spacing-small: ${theme.spacing.small};
    --spacing-medium: ${theme.spacing.medium};
    --spacing-large: ${theme.spacing.large};
    --spacing-x-large: ${theme.spacing.xLarge};
    --spacing-xx-large: ${theme.spacing.xxLarge};
    --spacing-xxx-large: ${theme.spacing.xxxLarge};
    --spacing-xxxx-large: ${theme.spacing.xxxxLarge};
    --spacing-giant: ${theme.spacing.giant};
    --spacing-x-giant: ${theme.spacing.xGiant};

    --small-devices: 576px;
    --large-devices: 1200px;

    --logo-width-small: 87px;
    --logo-width-large: 180px;
    --logo-height-small: 25.81px;
    --logo-height-large: 53.39px;

    --email-image-width-small: 200px;
    --email-image-width-large: 385px;

    --email-image-height-small: 225px;
    --email-image-height-large: 434.21px;
  }
`;

export const breakpoints = {
  small: '320px',
  medium: '500px',
  large: '1367px',
};
